import Loader from '@/components/ui/loader';
import { TypographyP2 } from '@heidi/design-system/typography';
import { useTranslations } from '@heidi/runtime/i18n';

const EhrSessionsListLoader = () => {
  const { t } = useTranslations();

  return (
    <div className="absolute left-0 top-0 z-50 flex size-full flex-col items-center justify-center gap-2 bg-surface/80">
      <Loader size={32} strokeWidth={3} className="text-text-secondary" />
      <TypographyP2 className="text-text-secondary">
        {t('sessions.processingSession')}
      </TypographyP2>
    </div>
  );
};

export default EhrSessionsListLoader;
